import { Briefcase } from 'lucide-react'
import { toast } from 'sonner'
import { MapaCargosDetailModal } from '@/components/Configuracao/mapaCargos/MapaCargosDetailModal'
import { MapaCargosList } from '@/components/Configuracao/mapaCargos/MapaCargosList'
import { formatMapaCargoDescricao } from '@/components/Configuracao/mapaCargos/mapaCargosUtils'
import { useMapaCargosTab } from '@/hooks/useMapaCargosTab'
import { useMapaCargosOverrides } from '@/hooks/useMapaCargosOverrides'
import { useAuthStore } from '@/stores/authStore'

export function MapaCargosTab() {
  const userRole = useAuthStore((state) => state.user?.role?.toLowerCase())
  const overridesState = useMapaCargosOverrides()
  const tab = useMapaCargosTab({
    ...overridesState,
    canEditEscopo: userRole === 'admin',
  })

  const handleCopy = async (cargo: Parameters<typeof formatMapaCargoDescricao>[0]) => {
    try {
      await navigator.clipboard.writeText(formatMapaCargoDescricao(cargo))
      toast.success('Descrição copiada')
    } catch {
      toast.error('Não foi possível copiar')
    }
  }

  return (
    <div className='glass-card space-y-6'>
      <div className='flex flex-wrap items-start justify-between gap-4'>
        <div>
          <h3
            className='flex items-center gap-2 font-semibold text-[var(--font-color-h3)]'
            style={{ fontSize: 'var(--font-size-h3)' }}
          >
            <Briefcase size={20} className='text-[var(--brand-primary)]' />
            Mapa de Cargos Oficiais
          </h3>
          <p className='mt-1 text-[var(--text-muted)]' style={{ fontSize: 'var(--font-size-sm)' }}>
            Consulte cargos, blocos de responsabilidade e descrições usadas em contratações PJ e chamados G5.
          </p>
        </div>
      </div>

      <div className='space-y-8'>
        <MapaCargosList cargos={tab.cargos} onView={tab.openCargo} onCopy={(cargo) => void handleCopy(cargo)} />
      </div>

      <MapaCargosDetailModal
        cargo={tab.selectedCargo}
        modalTab={tab.modalTab}
        onTabChange={tab.setModalTab}
        onClose={tab.closeModal}
        onCopy={(cargo) => void handleCopy(cargo)}
        canEditEscopo={tab.canEditEscopo}
        escopoEdit={tab.escopoEdit}
      />
    </div>
  )
}
